import Vue from "vue";
import moment from "moment-timezone";

Vue.filter("capitalize", function(value) {
	if (!value) return "";
	value = value.toString();
	let arr = value.split(" ");
	let capitalized_array = [];
	arr.forEach(word => {
		let capitalized = word.charAt(0).toUpperCase() + word.slice(1);
		capitalized_array.push(capitalized);
	});
	return capitalized_array.join(" ");
});

Vue.filter("truncate", function(value, limit) {
	return value.substring(0, limit);
});

Vue.filter("tailing", function(value, tail) {
	return value + tail;
});

Vue.filter("time", function(value, is24HrFormat = false) {
	if (value) {
		const date = new Date(Date.parse(value));
		let hours = date.getHours();
		const min = (date.getMinutes() < 10 ? "0" : "") + date.getMinutes();
		if (!is24HrFormat) {
			const time = hours > 12 ? "AM" : "PM";
			hours = hours % 12 || 12;
			return hours + ":" + min + " " + time;
		}
		return hours + ":" + min;
	}
});

Vue.filter("date", function(value, fullDate = false) {
	value = String(value);
	const date = value.slice(8, 10).trim();
	const month = value.slice(4, 7).trim();
	const year = value.slice(11, 15);

	if (!fullDate) return date + " " + month;
	else return date + " " + month + " " + year;
});

Vue.filter("month", function(val, showYear = true) {
	val = String(val);

	const regx = /\w+\s(\w+)\s\d+\s(\d+)./;
	if (!showYear) {
		return regx.exec(val)[1];
	} else {
		return regx.exec(val)[1] + " " + regx.exec(val)[2];
	}
});

Vue.filter("currency", function(value, currency = " VNĐ") {
	if (typeof value === "undefined" || value === null) return "";
	return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + currency;
});

Vue.filter("taskStatus", function(value) {
	switch (value) {
		case 0:
			return "New";
		case 1:
			return "Assigned";
		case 2:
			return "Rejected";
		case 4:
			return "Done";
		default:
			return "";
	}
});

Vue.filter("priorityStatus", function(value) {
	switch (value) {
		case 0:
			return "Low";
		case 1:
			return "Medium";
		case 2:
			return "High";
		case 3:
			return "Critical";
		default:
			return "";
	}
});

Vue.filter("isDoneStatus", function(value) {
	switch (value) {
		case true:
			return "Done";
		case false:
			return "Undone";
		default:
			return "";
	}
});

Vue.filter("lowerCaseFirstLetter", function(value) {
	return value.charAt(0).toLowerCase() + value.slice(1);
});

Vue.filter("dateTime", function(value, format = "HH:mm DD/MM/YYYY") {
	return moment(value).isValid() ? moment(value).format(format) : value;
});
